const isANumber = value => value.match(/^\d+$/);

export default isANumber;



// WEBPACK FOOTER //
// ./src/utils/isANumber.js